import React from "react";
import styled from "styled-components";
import LogePinPoint from "~/components/Map/Loge";
import PinkPin from "~/components/Map/PinkPin";
import { useTheme } from "~/guidelines/Theme/useTheme";
import { body2Bold } from "~/guidelines/Typography";

const PinPointContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

const PinPointLabel = styled.div`
  ${body2Bold};
  color: ${({ theme }) => theme.color.text.lightTertiary};
`;

export enum PinPointKing {
  Loge = "loge",
  PinkPin = "pinkPin",
  Unknown = "unknown",
}

const PinPoint = ({
  kind,
  label,
  miniMode = false,
}: {
  kind: PinPointKing;
  label: string;
  miniMode?: boolean;
}) => {
  const theme = useTheme();

  switch (kind) {
    case PinPointKing.Loge:
      return (
        <PinPointContainer>
          {!miniMode && <PinPointLabel>{label}</PinPointLabel>}
          <LogePinPoint miniMode={miniMode} />
        </PinPointContainer>
      );
    case PinPointKing.PinkPin:
      return (
        <PinPointContainer>
          {!miniMode && <PinPointLabel>{label}</PinPointLabel>}
          <PinkPin miniMode={miniMode} />
        </PinPointContainer>
      );
    default: {
      const pinSize = miniMode
        ? { width: "30", height: "30" }
        : { width: "49", height: "50" };

      return (
        <PinPointContainer>
          {!miniMode && <PinPointLabel>{label}</PinPointLabel>}
          <svg
            width={pinSize.width}
            height={pinSize.height}
            viewBox="0 0 49 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.209 19.5241C10.209 11.6228 16.5994 5.23242 24.5007 5.23242C32.4019 5.23242 38.7923 11.6228 38.7923 19.5241C38.7923 28.0378 29.7682 39.7774 26.0727 44.2487C25.2561 45.2287 23.7657 45.2287 22.949 44.2487C19.2332 39.7774 10.209 28.0378 10.209 19.5241ZM19.3965 19.5241C19.3965 22.3416 21.6832 24.6283 24.5007 24.6283C27.3182 24.6283 29.6048 22.3416 29.6048 19.5241C29.6048 16.7066 27.3182 14.4199 24.5007 14.4199C21.6832 14.4199 19.3965 16.7066 19.3965 19.5241Z"
              fill={theme.color.text.lightTertiary}
            />
          </svg>
        </PinPointContainer>
      );
    }
  }
};

export default PinPoint;
